import usePrivateAxios from "@/common/api/usePrivateAxios"
import { FeeTemplateUpdateValidationSchema } from "@/features/feeTemplates/schemas/create.schema"
import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

interface UseUpdateFeeTemplateProps {
  feeTemplateId?: string
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useUpdateFeeTemplate = ({ feeTemplateId, onSuccess, onError }: UseUpdateFeeTemplateProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateFeeTemplate'],
    mutationFn: async (form: FeeTemplateUpdateValidationSchema) =>
      privateAxios.put(`/billing/fee_templates/${feeTemplateId}`, {
        fee_template: {
          display_name: form.display_name,
        },
      }),
    onSuccess,
    onError,
  })
}
